import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
import { ToasterService } from '../services/toaster.service';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { RouterLink } from '@angular/router';
import { config } from '../config';
import { environment } from '../../environments/environment';
import *  as  productsMapping from './products-list.json';
declare var $: any;
@Component({
  selector: 'app-requested-quotes',
  templateUrl: './requested-quotes.component.html',
  styleUrls: ['./requested-quotes.component.css'],
  providers: [ToasterService]
})
export class RequestedQuotesComponent implements OnInit {
  requestedQuotesList: any = [];
  config: any = config;
  environment: any = environment;
  actionUrl: any;
  productsList: any = (productsMapping as any).default;
  userDetails: any = {};
  loading: boolean = false;
  quoteLength: any = 10;
  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(private router: Router, private toasterService: ToasterService, private _location: Location, private serviceURLService: serviceURLService) {
    this.userDetails.name = localStorage.getItem('name');
    this.userDetails.email = localStorage.getItem('email');
    this.userDetails.mobile = localStorage.getItem('mobileNumber');
  }

  ngOnInit() {
    this.actionUrl = this.environment.pam2Url + this.config.returningUserQuote;
    this.getRequestedQuotes();
  }

  // getRequestedQuotes() {
  //   this.loading = true;
  //   this.serviceURLService.retrieveQuoteListforRequestedQuotes(this.userDetails.mobile).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
  //     this.requestedQuotesList = successData.data.sort(this.sortData);
  //     this.loading = false;
  //   }), errorData => {
  //     this.loading = false;
  //   }
  // }

  getRequestedQuotes() {
    this.loading = true;
    this.serviceURLService.getRetrieveQuoteListUsingNotify(this.userDetails.mobile).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.requestedQuotesList = successData.response.pamResponse.data.sort(this.sortData);
      if(this.requestedQuotesList.length === 0){
        $('#quoteModal').modal('show');
      }
      this.loading = false;
    }), errorData => {
      this.loading = false;
    }
  }

  // quotes data sort according to date
  sortData = (a, b) => {
    const bandA = a.date.toUpperCase();
    const bandB = b.date.toUpperCase();
    let comparison = 0;
    if (bandA < bandB) {
      comparison = 1;
    } else if (bandA > bandB) {
      comparison = -1;
    }
    return comparison;
  }


  createProspect() {
    this.loading = true;
    window.open(`${this.environment.pam2Url}`, '_blank');
    this.loading = false;
  }

  redirectUserToProductPage(prospectId) {
    this.loading = true;
    var formData = new FormData()
    formData.append('prospectId', prospectId);
    this.serviceURLService.getProductUrl(formData).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      window.location.href = successData.data.productURL;
      this.loading = false;
    }, errorData => {
      this.loading = false;
    });
  }

  routeToQuotePage(data){
    window.location.href= this.actionUrl +data;
  }
  // getImagesName(insurer) {
  //   var imgName;
  //   if (insurer) {
  //     if (insurer == 'unitedIndiaAssurance') {
  //       imgName = "united-india.png"
  //     } else if (insurer == 'raheja') {
  //       imgName = "raheja-qbe.png"
  //     } else if (insurer == 'royalSundaram') {
  //       imgName = 'royal-sundaram.png'
  //     } else if (insurer == 'hdfcErgo') {
  //       imgName = "hdfc-gic.png"
  //     } else if (insurer == 'newIndiaAssurance') {
  //       imgName = "new-india.png"
  //     } else if (insurer == 'futureGenerali') {
  //       imgName = "future_general.jpg"
  //     }  else if (insurer == 'religareHealth') {
  //       imgName = "religare.png"
  //     } 
  //   }
  //   return 'https://s3.ap-south-1.amazonaws.com/static-files-website/insurers/' + imgName;
  // }

  // returningUserQuote(quoteId) {
  //   this.serviceURLService.returningUserQuote(quoteId).subscribe((successData :any) => {

  //   }), errorData => {

  //   }
  // }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

};
